import VendorPortalHeader from "./VendorPortalHeader";

export default VendorPortalHeader;
